// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"d47d4c888784db6ccbb7","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"37e3469602c506705244","vendors-node_modules_rehype-highlight_index_js":"9a1aa4e77ec802149729"}[chunkId] + "";
};